// Local accommodation tax (poplatek z pobytu) helpers — Czech zákon
// č. 565/1990 Sb. § 3b exempts only guests under 18. Some municipalities
// historically exempted seniors too via their own vyhláška, but Štramberk
// (and the law itself) does not. Until we add per-camp configuration, we
// apply the strictest rule: only <18 is exempt. Age evaluated on arrival.

export const ageOnDate = (dateOfBirth: string, referenceDate: string): number => {
    const [dobY = 0, dobM = 0, dobD = 0] = dateOfBirth.split("-").map(Number)
    const [refY = 0, refM = 0, refD = 0] = referenceDate.split("-").map(Number)
    let age = refY - dobY
    if (refM < dobM || (refM === dobM && refD < dobD)) age--
    return age
}

export const isTaxableAge = (dateOfBirth: string, arrivalDate: string): boolean => {
    const age = ageOnDate(dateOfBirth, arrivalDate)
    return age >= 18
}

// Number of nights of a stay that fall inside [from, to].
// Inclusive of arrival, exclusive of departure.
export const nightsInWindow = (
    arrivalDate: string,
    departureDate: string,
    from: string,
    to: string,
): number => {
    const dayMs = 86_400_000
    const arr = new Date(arrivalDate + "T00:00:00Z").getTime()
    const dep = new Date(departureDate + "T00:00:00Z").getTime()
    const winFrom = new Date(from + "T00:00:00Z").getTime()
    const winTo = new Date(to + "T00:00:00Z").getTime()
    const start = Math.max(arr, winFrom)
    const end = Math.min(dep, winTo + dayMs)
    if (end <= start) return 0
    return Math.round((end - start) / dayMs)
}

// Per-guest tax for a single reservation, derived from priceBreakdown.
// `priceBreakdown.taxes` is the total tax amount for the reservation in
// minor units (haléře). Splitting it across taxable guests gives the
// per-guest amount that we display in the city report.
export const perGuestTax = (
    priceBreakdownTaxes: number | undefined,
    taxableGuestCount: number,
): number => {
    if (!priceBreakdownTaxes || taxableGuestCount <= 0) return 0
    return Math.round(priceBreakdownTaxes / taxableGuestCount)
}
